import { queryGet } from '@/api/apiConfig';

export default {
  getPrices () {
    return queryGet('/api/app/jacket').then((response) => {
      return response;
    });
  },
};
